import React from 'react';

const Downloads = (props) => {

    return (
        <React.Fragment >
            <div className="wrapper wrapperContent">
                <h1>Downloads</h1>

                {props.model.items.map( item => (
                    <a href={item.url} download={item.download} style={{textDecoration: 'none', color: '#000000', fontSize: '24px'}}>

                        <div className="grid" style={{padding: 10}}>
                            <div style={{width: 35}}>
                                <img src={require("./assets/pdf.webp")} alt="Foerderverein" style={{width: 25}} />
                            </div>
                            <div className="col">
                                <div>{item.label}</div>
                            </div>
                        </div>
                    </a>
                ))}

            </div>
        </React.Fragment>
    );
};

export default Downloads;
